import type { LinkProps } from "ui/components/Link";
import Link from "ui/components/Link";
import cx from "ui/cx";
import IconCollapseAll from "ui/icons/IconCollapseAll";
import IconExpandAll from "ui/icons/IconExpandAll";
import styles from "./ExpandCollapse.module.scss";

export type ExpandCollapseProps = LinkProps & {
  expanded: boolean;
  size?: number;
};

export default function ExpandCollapse({ expanded, className, size = 14, ...props }: ExpandCollapseProps) {
  const Component = expanded ? IconCollapseAll : IconExpandAll;
  return (
    <Link {...props} className={cx(styles.wrapper, className)} title={expanded ? "Collapse all" : "Expand all"}>
      <Component size={size} />
    </Link>
  );
}
